// Copyright © 2019-2026 Focal Systems. All rights reserved.

import type { LucideIcon } from "lucide-react";
import { Button } from "@/components/ui/button";

interface FilterToggleProps {
  active: boolean;
  onChange: (active: boolean) => void;
  icon: LucideIcon;
  label: string;
  disabled?: boolean;
}

export function FilterToggle({ active, onChange, icon: Icon, label, disabled }: FilterToggleProps) {
  return (
    <Button
      variant="outline"
      disabled={disabled}
      className={
        active
          ? "bg-sidebar-accent-hover hover:bg-sidebar-accent border-sidebar-accent hover:border-sidebar-primary text-sidebar-accent-foreground hover:text-sidebar-accent-foreground dark:bg-sidebar-accent dark:border-sidebar-accent dark:hover:bg-sidebar-accent-hover dark:hover:border-sidebar-primary"
          : "font-normal border-dashed"
      }
      onClick={() => onChange(!active)}
    >
      <Icon className={`h-4 w-4 ${active ? "fill-sidebar-primary/25" : ""}`} />
      {label}
    </Button>
  );
}
